<template>
    <div class="col-xl-4 col-md-12">
        <div class="card">
            <div class="card-header pb-0">
                <h1 style="font-size: 50px;">Ticket Volume Trend</h1>
                <p style="font-size: 32px;" class="f-light">ปริมาณตั๋วที่เข้ามา vs ตั๋วที่ปิดได้</p>
            </div>
            <div class="card-body">
                <div id="ticket-volume-chart">
                    <apexchart
                        type="line"
                        height="420"
                        :options="chartOptions"
                        :series="series"
                    ></apexchart>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import VueApexCharts from 'vue3-apexcharts'

const series = ref([
    {
        name: 'ตั๋วเข้า',
        data: [8, 12, 18, 9, 15, 20, 10] // ตัวอย่างข้อมูล อาทิตย์-เสาร์
    },
    {
        name: 'ปิดงานแล้ว',
        data: [3, 5, 10, 7, 12, 14, 6] // ตัวอย่างข้อมูล อาทิตย์-เสาร์
    }
])

const chartOptions = ref({
    chart: {
        height: 350,
        type: 'line',
        toolbar: {
            show: false
        },
        zoom: {
            enabled: false
        }
    },
    colors: ['#7366ff', '#54ba4a'],
    dataLabels: {
        enabled: false
    },
    stroke: {
        curve: 'smooth',
        width: 3
    },
    grid: {
        borderColor: '#e7e7e7',
        row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
        }
    },
    markers: {
        size: 4
    },
    xaxis: {
        categories: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
        labels: {
            style: {
                fontSize: '28px',
                fontWeight: 'bold'
            }
        }
    },
    yaxis: {
        title: {
            style: {
                fontSize: '32px',
                fontWeight: 'bold'
            }
        },
        labels: {
            style: {
                fontSize: '28px',
                fontWeight: 'bold'
            }
        }
    },
    legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        floating: false,
        fontSize: '28px',
        fontWeight: 'bold',
        labels: {
            colors: ['#7366ff', '#54ba4a'],
            useSeriesColors: true
        }
    }
})
</script>
